import { type ConfigArea, type PermissionSetEntity } from '@omnea-app/authz'
import type { AuthzContextState } from './useAuthzContextQuery'

type ResolvedAuthzContext = Extract<AuthzContextState, { status: 'resolved' }>

export type AuthzCheck = (authz: ResolvedAuthzContext) => boolean

export const hasEntityAccess =
  (entity: PermissionSetEntity): AuthzCheck =>
  ({ entities }) =>
    entities.has(entity)

/** Whether the caller administers a configuration area — what a settings route's config gate asks. */
export const managesConfigArea =
  (area: ConfigArea): AuthzCheck =>
  ({ managedAreas }) =>
    managedAreas.has(area)

export const managesPermissions: AuthzCheck = ({ canManagePermissions }) => canManagePermissions
